import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Account } from 'images/latest'

const AccountIcon = ({ color = 'white' }) => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56', stroke: color }}
    SVG={Account}
  />
)

export default AccountIcon
